import React from 'react';
import {connect} from 'react-redux';
import {Form} from 'react-redux-form';
import {Col, Row} from 'react-bootstrap';
import RequiredInput from '../../common/form/elements/required-input';
import RequiredTextarea from '../../common/form/elements/required-textarea';
import ArrowButton from '../../common/button-arrow';

class ContactForm extends React.Component {
  render() {
    const {onSubmit, formValid, model} = this.props;

    return (
      <Form model={model} onSubmit={onSubmit}>
        <Row>
          <Col lg={12}>
            <RequiredInput disabled label="From" model=".from"/>
            <RequiredInput disabled label="Subject" model=".subject"/>
            <RequiredTextarea label="Message" model=".message"/>
            <ArrowButton arrow={false} disabled={!formValid}>
              Submit
            </ArrowButton>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.contact_us_team.$form.valid,
});

export default connect(mapStateToProps)(ContactForm);



// WEBPACK FOOTER //
// ./src/components/team/contact-us/contact-us-form.jsx